import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/usuarios',documento:'catalogs',acceso:'sesion',filas:['075'],cita:'Areas/Catalogs/Controllers/UsersController.cs:50'} satisfies RutaProd;
